import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import Flash from './components/Flash';
import KurlonPrice from './components/KurlonPrice';
import SleepwellPrice from './components/SleepwellPrice';
import Trends from './components/Trends';
import Reports from './components/Reports';
import Availability from './components/Availability';
import DashboardLayout from './layouts/DashboardLayout';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { AuthProvider, RequireAuth } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';

function App() {


  return (
    <>
      <Provider store={store}>
        <AuthProvider>
          <ToastContainer
            position='bottom-left'
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='colored'
          />
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LoginPage />} />

              {/* Dashboard : Auth Guard implemented */}
              <Route path='/dashboard' element={
                <RequireAuth>
                  <DashboardLayout />
                </RequireAuth>
              }>
                <Route path="flash" element={<Flash />} />
                <Route path="kurlon" element={<KurlonPrice />} />
                <Route path="sleepwell" element={<SleepwellPrice />} />
                <Route path="availability" element={<Availability />} />
                <Route path="trends" element={<Trends />} />
                <Route path="reports" element={<Reports />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </Provider>
    </>
  );
}

export default App;
